<template>
  <v-app v-if="v3Migration" id="sga" class="colorMainBackground colorDefault">
    <V3Migration />
  </v-app>
  <v-app
    id="sga"
    class="colorMainBackground colorDefault"
    :class="onMigration ? 'oxeBetMigration' : ''"
    v-else-if="onMaintenance"
  >
    <OnMigration v-if="onMigration" />
    <OnMaintenance v-else :seconds="31" />
  </v-app>
  <v-app
    id="sga"
    class="colorMainBackground colorDefault"
    v-else
    :style="$route.name == 'casino-game' ? 'z-index: 3000000000' : ''"
  >
    <vue-progress-bar></vue-progress-bar>

    <Notification />
    <Feedback />
    <BetCard class="d-none" />

    <DialogDepositPay4Fun v-if="$isCreditOnline()" z-index="10" />
    <DialogDeposit v-else />

    <DialogMotivePay4Fun />

    <DialogBlockUser />

    <DialogRegister idDialog="general" :hideDialogRegisterButtons="true" />

    <DialogConfirmRegister />

    <DialogConfirmPhoneOrEmailChange />

    <DialogVerifySmsToken />

    <TimeActivity />

    <router-view />

    <v-overlay
      :value="FirstContentfulPaint"
      z-index="999999"
      opacity="0.8"
      class="text-center justify-center"
    >
      <div style="margin-bottom: 200px">
        <img width="160" :src="src" :alt="domain" />
        <div style="width: 32px; margin: 0 auto; margin-top: 32px">
          <v-progress-linear indeterminate size="100"></v-progress-linear>
        </div>
      </div>
    </v-overlay>
    <!-- Botão que leva o usuário ao topo da página -->
    <BtnScroll />
  </v-app>
</template>

<script>
// Components - @/components
import Notification from "@/components/notification/notification";
import Feedback from "@/components/feedback/feedback";
import BetCard from "@/components/agent/Backoffice/bet/BetCard";
import DialogDeposit from "@/components/dialog-deposit/dialog-deposit";
import DialogDepositPay4Fun from "@/components/dialog-deposit/dialog-deposit-pay4Fun";
import DialogMotivePay4Fun from "@/components/dialog-motive/dialog-motive-pay4Fun";
import DialogBlockUser from "@/components/dialog-block-user/DialogBlockUser.vue";
import DialogRegister from "@/views/home/register/dialog-register.vue";
import DialogConfirmRegister from "@/views/valid-register";
import DialogConfirmPhoneOrEmailChange from "@/views/confirmEmailOrPhoneChange";
import { injectAnalytics, injectGTM } from "@/util/analytics.js";
import { operatorLogoUrl, operatorFaviconUrl } from "@/util/assets";
import BtnScroll from "@/components/btn-scroll-to-top/";
import TimeActivity from "@/components/notification/timeActivity.vue";
import OnMaintenance from "@/components/maintenance/OnMaintenance.vue";
import DialogVerifySmsToken from "./components/dialog-verify-sms-token/DialogVerifySmsToken.vue";
import OnMigration from "@/components/maintenance/OnMigration.vue";
import V3Migration from "@/components/v3Migration/V3Migration.vue";

export default {
  name: "app",
  components: {
    Notification,
    Feedback,
    BetCard,
    DialogDeposit,
    DialogDepositPay4Fun,
    DialogBlockUser,
    DialogRegister,
    DialogConfirmRegister,
    DialogConfirmPhoneOrEmailChange,
    BtnScroll,
    TimeActivity,
    OnMaintenance,
    DialogMotivePay4Fun,
    DialogVerifySmsToken,
    OnMigration,
    V3Migration,
  },
  data: () => ({
    FirstContentfulPaint: null,
    domain: "",
    onMaintenance: false,
    onMigration: false,
    src: "",
    v3Migration: false,
  }),

  mounted() {
    const v3MigrationToJogoDeOuro = [
      "a3bet",
      "sportshowpix",
      "betpremier",
      "betgol",
      "betpix",
      "pixbrasil",
      "placarbets",
      "nubet",
      "nbet91",
      "betgol777",
      "trevosports",
      "sbet355",
      "elitexbetnet",
      "imperialbetcom",
      "18kbetonline",
      "betnaveia",
      "recpix",
      "streetbet"
    ];

    if (v3MigrationToJogoDeOuro.includes(this.$domain())) {
      this.v3Migration = true;
      return;
    }

    if (window.location.hostname === "www.sullbet.com") {
      window.location = "sullbet.com";
    } else if (this.$domain() === "jogodeourobet") {
      window.location = "https://jogodeouro.bet/pt/sports#/overview";
    }

    const onMaintenanceDomains = [
      "a3bet",
      "sportshowpix",
      "betpremier",
      "betgol",
      "betpix",
      "pixbrasil",
      "placarbets",
      "nubet",
      "nbet91",
      "betgol777",
      "trevosports",
      "sbet355",
      "elitexbetnet",
      "imperialbetcom",
      "18kbetonline",
      "betnaveia",
      "recpix",
      "streetbet",
      "amabet"
    ];

    if (onMaintenanceDomains.includes(this.$domain())) {
      this.onMaintenance = true;
      return;
    }

    const redirectToCasino = localStorage.getItem("redirectToCasino");

    if (redirectToCasino && JSON.parse(redirectToCasino)) {
      this.$router.push({ name: "casinoHome" });
      localStorage.removeItem("redirectToCasino");
    }

    if (this.$domain() === "cartola") {
      setTimeout(() => {
        window.apg_bf9ef0d1_f4fb_497d_929b_c7d9c6afea38.init();
      }, 1000);
    }

    // let deploymentUrl =
    //   typeof window !== "undefined" && window.location.origin
    //     ? window.location.origin
    //     : false;

    // if (
    //   deploymentUrl &&
    //   !deploymentUrl.includes("local") &&
    //   !deploymentUrl.includes("192.168")
    // ) {
    //   this.compareVersions(deploymentUrl).then((result) => {
    //     if (result) {
    //       caches.keys().then(function(names) {
    //         for (let name of names) caches.delete(name);
    //       });
    //       window.location.reload();
    //     }
    //   });
    // }

    if (this.onMaintenance) {
      return;
    }

    const blockAfterReload = JSON.parse(
      localStorage.getItem("blockAfterReload")
    );

    if (blockAfterReload) {
      this.$store.commit("resetCounterOfErrors500");

      setTimeout(() => {
        localStorage.setItem("blockAfterReload", JSON.stringify(false));
      }, 30000);

      this.onMaintenance = true;
    }

    this.setIpOnHeader();
    this.domain = this.$domain();

    // logo loading custom
    switch (this.domain) {
      case "bellosports":
      case "planetbet":
      case "betina123":
      case "betsprime":
      case "sonhobet":
      case "sonhobetcom":
      case "apostador":
      case "paybet":
      case "panibet":
      case "dasorte":
      case "betdasorte":
      case "deboa":
      case "bet24hs":
      case "bateubet":
      case "sabiobet":
        this.src = `https://dozr8la71aog.cloudfront.net/domains/${this.domain}/img/logo_loading.png`;
        break;
      default:
        this.src = operatorLogoUrl(this.domain);
        break;
    }

    // reset dialog
    this.$store.commit("setDialogEvent", false);
    // store breakpoint name
    this.$store.commit("setBreakpointName", this.$vuetify.breakpoint.name);

    // FirstContentfulPaint Logic "Otmized with requestAnimationFrame"
    this.FirstContentfulPaint = true;
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      if (progress < 3000) {
        window.requestAnimationFrame(step);
      } else {
        close();
      }
    }
    window.requestAnimationFrame(step);
    const close = () => {
      this.FirstContentfulPaint = false;
    };

    // ===============================================//
    // VERIFICAÇÃO DE SEGURANÇA DA SESSÃO:            //
    // ===============================================//
    document.addEventListener("visibilitychange", function() {
      const auth = localStorage.getItem("auth");
      const isAuth = auth === "true";

      if (isAuth) {
        verifyAuth();
      } else {
        logoutTab();
      }
    });

    const verifyAuth = () => {
      if (!this.$store.state.logged.status) {
        this.$router.go();
      }
    };

    const logoutTab = () => {
      if (this.$store.state.logged.status) {
        this.$router.go();
      }
    };

    // ***********************************************//
    // END. VERIFICAÇÃO DE SEGURANÇA DA SESSÃO.       //
    // ===============================================//

    // ===============================================//
    // DINAMIC MANIFEST FOR DOMAINS:                  //
    // ===============================================//

    // Define operator name:
    // First access, not function
    // define operator name for domain name and set uppercase first caracter.
    const operator = this.$store.state.operators.operator_name
      ? this.$store.state.operators.operator_name
      : this.domain.charAt(0).toUpperCase() + this.domain.slice(1);

    const domain = this.domain;
    const color = this.$vuetify.theme.themes.dark.colorAppBar;
    const start_url = `${window.location.protocol}//${window.location.hostname}/`;
    var DynamicManifest = {
      name: `${operator}`,
      short_name: `${operator}`,
      theme_color: color,
      icons: [
        {
          src: `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/android-chrome-192x192.png`,
          sizes: "192x192",
          type: "image/png",
        },
        {
          src: `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/android-chrome-512x512.png`,
          sizes: "512x512",
          type: "image/png",
        },
        {
          src: `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/android-chrome-maskable-192x192.png`,
          sizes: "192x192",
          type: "image/png",
          purpose: "maskable",
        },
        {
          src: `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/android-chrome-maskable-512x512.png`,
          sizes: "512x512",
          type: "image/png",
          purpose: "maskable",
        },
      ],
      start_url: `${start_url}`,
      display: "standalone",
      background_color: "#000000",
    };
    const stringManifest = JSON.stringify(DynamicManifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
    document
      .querySelector("link[rel='manifest']")
      .setAttribute("href", manifestURL);

    // ===============================================//
    // DINAMIC CHANGES FOR DOMAINS IN S3:             //
    // ===============================================//

    // Dinamic Change FAVICON
    const favicon32 = document.querySelector("link[sizes='32x32']");
    favicon32.setAttribute("href", operatorFaviconUrl("32x32", domain));
    const favicon16 = document.querySelector("link[sizes='16x16']");
    favicon16.setAttribute("href", operatorFaviconUrl("16x16", domain));

    // Dinamic change Apple Touch Icon
    const appleTouchIcon = document.querySelector(
      "link[rel='apple-touch-icon']"
    );
    appleTouchIcon.setAttribute(
      "href",
      `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/apple-touch-icon-152x152.png`
    );

    // Dinamic Change msapplication-TileImage
    const msapplication = document.querySelector(
      "meta[name='msapplication-TileImage']"
    );
    msapplication.setAttribute(
      "content",
      `https://dozr8la71aog.cloudfront.net/domains/${domain}/img/icons/msapplication-icon-144x144.png`
    );

    // Dinamic Change Theme Color
    const themecolor = document.querySelector("meta[name='theme-color']");
    themecolor.setAttribute("content", color);

    // Dinamic Change Apple mobile web App Title
    const appleMobileWebAppTitle = document.querySelector(
      "meta[name='apple-mobile-web-app-title']"
    );
    appleMobileWebAppTitle.setAttribute("content", `${operator}`);

    // Dinamic Change Description
    if (this.$isCreditOnline() && operator != "Bet Da Sorte") {
      const description = document.querySelector("meta[name='Description']");
      description.setAttribute(
        "content",
        `${operator} - Apostas Esportivas Online e Apostas Ao vivo. Depósito e saques instantâneos com Pix. Aposte em diversos Esportes e muito mais com a ${operator}.`
      );
    }

    // Google NoIndex
    // var noindex = ["imperialbet"];
    // if (noindex.includes(domain)) {
    //   // <meta name="robots" content="noindex">
    //   // https://developers.google.com/search/docs/advanced/crawling/remove-information?hl=pt-br
    //   var meta = document.createElement("meta");
    //   meta.name = "robots";
    //   meta.content = "noindex";
    //   var head = document.getElementsByTagName("head")[0];
    //   head.insertBefore(meta, head.childNodes[0]);
    // }

    // x.:

    // INJECT ANALYTICS (PIXEL FACEBOOK, GOOGLE ANALYTICS);
    injectAnalytics();
  },
  computed: {
    counterOfErrors500() {
      return this.$store.getters.getCounterOfErrors500;
    },
  },
  watch: {
    counterOfErrors500() {
      if (this.counterOfErrors500 >= 5) {
        localStorage.setItem("blockAfterReload", JSON.stringify(true));
        this.onMaintenance = true;
        setTimeout(() => {
          localStorage.setItem("blockAfterReload", JSON.stringify(false));
        }, 30000);
      }
    },
    "$route.query"(query) {
      if (query.loginExemptPlayer) {
        const queryLoginExemptPlayer = JSON.parse(query.loginExemptPlayer);

        const currentURL = new URL(window.location.href);
        const fullPathUpdated = new URLSearchParams(currentURL.search);

        fullPathUpdated.delete("loginExemptPlayer");

        window.history.replaceState(
          {},
          "",
          `${location.pathname}?${fullPathUpdated}`
        );

        this.$loginAutomatic(queryLoginExemptPlayer);
      }
    },
    // workaround pro reload após infotable
    "$store.state.operators"(newVal, oldVal) {
      if (newVal.google_tag_manager && Object.keys(oldVal).length === 0) {
        injectGTM(newVal.google_tag_manager);
      }

      if (newVal.home_page === "casino" && !oldVal.home_page) {
        localStorage.setItem("redirectToCasino", true);
      }
    },
  },
  methods: {
    setIpOnHeader() {
      if (this.$store.state.userIp) {
        this.$axios.defaults.headers.ip = this.$store.state.userIp;
        return;
      }

      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          this.$store.commit("setIp", ip);
          this.$axios.defaults.headers.ip = ip;
        });
    },
    async compareVersions(deploymentUrl) {
      try {
        let newVersion = false;
        const SCRIPT_REJEX_MAIN = /^.*<script.*\/(app.*\.js).*$/gim;
        const fetchedPage = await fetch(deploymentUrl);
        const loadedText = await fetchedPage.text();
        const matchResponses = SCRIPT_REJEX_MAIN.exec(loadedText);
        let remoteMainScript =
          matchResponses.length > 0 ? matchResponses[1] : undefined;
        if (remoteMainScript === undefined) {
          console.log("Could not find main script in index.html");
          return false;
        }
        let currentMainScript = undefined;
        const scriptTags = document.head.querySelectorAll("link");
        for (let i = 0; i < scriptTags.length; i++) {
          const scriptTag = scriptTags[i];
          currentMainScript =
            /^.*\/(app.*\.js).*$/gim.exec(scriptTag.href) === null
              ? undefined
              : /^.*\/(app.*\.js).*$/gim.exec(scriptTag.href)[1];
          if (!!currentMainScript && !!remoteMainScript) {
            newVersion = currentMainScript !== remoteMainScript;
            console.log({ newVersion, currentMainScript, remoteMainScript });
          }
        }
        return newVersion;
      } catch (e) {
        return false;
      }
    },
  },
};
</script>
<style>
.oxeBetMigration {
  background-image: linear-gradient(
    to bottom,
    #06031b,
    #2d217e,
    #06031b
  ) !important;
  background-attachment: fixed !important;
}
</style>
